import { render, staticRenderFns } from "./SJT.vue?vue&type=template&id=1f0b9247&scoped=true&"
import script from "./SJT.vue?vue&type=script&lang=js&"
export * from "./SJT.vue?vue&type=script&lang=js&"
import style0 from "./SJT.vue?vue&type=style&index=0&id=1f0b9247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b9247",
  null
  
)

export default component.exports